




























import { Component, Vue, Prop } from 'vue-property-decorator';
import UserProfile from '@/classes/UserProfile';

@Component
export default class MaterialShipToUser extends Vue {
    @Prop() public userId!: number;

    public get user(): UserProfile | undefined {
        const user: UserProfile = this.$store.getters['users/getUserProfileById'](this.userId);
        return user;
    }
}
